import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const CommitteeMembersTableHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <thead>
      <tr className="nk-tb-item nk-tb-head tb-tnx-head fs-11px">
        <th className="nk-tb-col">
          <span>{t('Name')}</span>
        </th>
        <th className="nk-tb-col tb-col-xl">
          <span>{t('FiscalIdentification')}</span>
        </th>
        <th className="nk-tb-col tb-col-hide">
          <span>{t('Nationality')}</span>
        </th>
        <th className="nk-tb-col tb-col-xl">
          <span>{t('AppointmentDate')}</span>
        </th>
        <th className="nk-tb-col tb-col-xl">
          <span>{t('EndDate')}</span>
        </th>
        <th className="nk-tb-col tb-col-hide">
          <span>{t('DateOfBirth')}</span>
        </th>
        <th className="nk-tb-col">
          <span>{t('Status')}</span>
        </th>
        <th className="nk-tb-col tb-col-xl">
          <span>{t('MemberCondition')}</span>
        </th>
        <th className="nk-tb-col">
          <span>{t('Position')}</span>
        </th>
      </tr>
    </thead>
  );
};

export default CommitteeMembersTableHeader;
